import { feedbackFormSlice } from '../store/slices/feedbackSlice';

export const { setFeedbackFormInFocus: feedbackSessionFormInFocus } = feedbackFormSlice.actions;
